<template>
  <div @touchmove.prevent class="model-mask" v-if="show">
    <div class="logistics-info">
      <div class="form">
        <div class="epxpress-company">
          <em>快递公司</em>
          <vm-select disabled placeholder="请选择" v-model="expressInfo.return_compnay"></vm-select>
        </div>
        <div class="express-number">
          <em>运单号</em>
          <input disabled placeholder="请输入快递单号" type="text" v-model="expressInfo.return_express_no" />
        </div>
      </div>
      <div class="handler-btn">
        <button @click="close" class="cancel">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import { VmSelect } from 'vue-multiple-select'
export default {
  name: 'lookInfo',
  components: {
    VmSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    expressInfo: {
      type: Object
    }
  },
  methods: {
    close () {
      this.$emit('closeLookLogisticsInfo', false)
    }
  }
}
</script>
<style>
.el-input__inner {
  width: 3.93rem;
  height: 0.74rem;
  border: 0.5px solid #979797;
  padding-left: 0.2rem;
}
.el-select-dropdown__wrap {
  max-height: 2.5rem;
}
</style>
<style lang="less" scoped>
.logistics-info {
  width: 6.3rem;
  height: 4.5rem;
  background-color: #fff;
  border-radius: 0.14rem;
  font-size: 0.24rem;
  color: #404040;
  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0.6rem;
    em {
      width: 0.96rem;
      text-align: right;
      display: inline-block;
      margin-right: 0.25rem;
    }
    input {
      width: 3.93rem;
      height: 0.74rem;
      border: 0.5px solid #979797;
      box-sizing: border-box;
      padding-left: 0.2rem;
      border-radius: 4px;
    }
    input::-webkit-input-placeholder {
      color: #c0c4cc;
    }
    input:focus {
      border-color: #409eff;
    }
    .express-company {
    }
    .express-number {
      margin-top: 0.45rem;
    }
  }
  .handler-btn {
    width: 4.64rem;
    display: flex;
    justify-content: center;
    margin: 0.5rem auto 0;
    button {
      width: 2rem;
      height: 0.8rem;
      color: #fff;
      font-size: 0.32rem;
      border-radius: 0.08rem;
    }
    .cancel {
      color: #666;
      background-color: #f0f0f0;
    }
  }
}
</style>
